export let ifCond = (v1, operator, v2, options) => {
	switch (operator) {
		case '==':
			return (v1 == v2) ? options.fn(this) : options.inverse(this);
		case '===':
			return (v1 === v2) ? options.fn(this) : options.inverse(this);
		case '!=':
			return (v1 != v2) ? options.fn(this) : options.inverse(this);
		case '!==':
			return (v1 !== v2) ? options.fn(this) : options.inverse(this);
		case '<':
			return (v1 < v2) ? options.fn(this) : options.inverse(this);
		case '<=':
			return (v1 <= v2) ? options.fn(this) : options.inverse(this);
		case '>':
			return (v1 > v2) ? options.fn(this) : options.inverse(this);
		case '>=':
			return (v1 >= v2) ? options.fn(this) : options.inverse(this);
		case '&&':
			return (v1 && v2) ? options.fn(this) : options.inverse(this);
		case '||':
			return (v1 || v2) ? options.fn(this) : options.inverse(this);
		default:
			return options.inverse(this);
	}
};

export let math = (lvalue, operator, rvalue) => {
	lvalue = parseFloat(lvalue);
	rvalue = parseFloat(rvalue);
	return {
		'+': lvalue + rvalue,
		'-': lvalue - rvalue,
		'*': lvalue * rvalue,
		'/': lvalue / rvalue,
		'%': lvalue % rvalue
	}[operator];
};

export let mathAbs = (value) => {
	value = parseFloat(value);
	return Math.abs(value);
};

export let object = ({ hash }) => {
	return hash;
};

export let strToArr = (str) => {
	return str.split(',');
};



// WEBPACK FOOTER //
// ../helpers/handlebarsHelpers.js